import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Sidebar.css';

const Sidebar = () => {

    const [active, setActive] = useState(false);

    document.onclick = function (e) {
        if (e.target.id !== 'sidebar' && e.target.id !== 'menu-bars' && e.target.id !== 'header') {
            setActive(false);
        }
    }
    return (
        <div id='sidebar'>

            <div onClick={()=> active ? setActive(false): setActive(true)} id="menu-bars" className={active ? 'fas fa-times': 'fas fa-bars'}></div>
                
            <header id='header' className={active ? 'active': '' }>

                <Link to="/" className="logo"> <span>Naime</span> Molla </Link>

                <nav className="navbar">
                    <Link to="naime">Naime</Link>
                    <Link to="skills">Skills</Link>
                    <Link to="projects">Projects</Link>
                    <Link to="blog">My Blog</Link>
                    <Link to="about">About Me</Link>
                    <Link to="contact">Contact</Link>
                </nav>

                <div className="follow">
                    <a href="https://www.facebook.com/naime0ahmed"><i className="fab fa-facebook"></i></a>

                    <a href="https://github.com/naime-ahmed"><i className="fab fa-github"></i></a>

                    <a href="https://www.instagram.com/namie_ahmed/"><i className="fab fa-instagram"></i></a>

                    <a href="https://www.linkedin.com/in/md-naime-molla16/"><i className="fab fa-linkedin"></i></a>
                </div>

            </header>
            
        </div>
    );
};

export default Sidebar;